// Asegúrate de que GSAP y ScrollTrigger estén cargados.
// Idealmente, esto se hace en el theme.liquid o en un archivo JS principal.
// Si no, puedes añadirlos aquí, pero es mejor que estén cargados globalmente si los usas mucho.
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js"></script>
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js"></script>

document.addEventListener('DOMContentLoaded', function() {
  // Solo ejecuta si GSAP y ScrollTrigger están disponibles
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Animación para la imagen del producto
    gsap.from('.producto-imagen-aove img', {
      scale: 0.9,
      opacity: 0,
      duration: 1.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '#producto-unico-aove', // ID de la sección
        start: 'top 70%' // Cuando el 70% superior de la sección entra en el viewport
      }
    });

    // Animación para los detalles del producto
    gsap.from('.producto-detalles-aove > *', {
      x: 30, // Se mueve desde la derecha
      opacity: 0,
      stagger: 0.15, // Retraso escalonado para cada elemento hijo
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '#producto-unico-aove', // ID de la sección
        start: 'top 65%' // Cuando el 65% superior de la sección entra en el viewport
      }
    });
  } else {
    console.warn("GSAP o ScrollTrigger no están cargados. Las animaciones del producto AOVE no se ejecutarán.");
  }
}); 

